import { useEffect, useState } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { navigateToLatestRelease } from '../../utils/appReleaseNavigate';
import { isChunkLoadError, reloadOnceForStaleChunk } from '../../utils/chunkLoadError';

const ROUTE_ERROR_BODY_ATTR = 'data-app-route-error';

const RouteErrorBoundary = () => {
	const error = useRouteError();
	const chunkStale = isChunkLoadError(error);
	const [isPreparing, setIsPreparing] = useState(chunkStale);

	useEffect(() => {
		document.body.setAttribute(ROUTE_ERROR_BODY_ATTR, '1');
		return () => {
			document.body.removeAttribute(ROUTE_ERROR_BODY_ATTR);
		};
	}, []);

	useEffect(() => {
		if (!chunkStale) return undefined;
		if (reloadOnceForStaleChunk()) return undefined;
		setIsPreparing(false);
		return undefined;
	}, [chunkStale]);

	const title = chunkStale ? '系统已更新' : '页面加载失败';
	const description = chunkStale
		? isPreparing
			? '正在刷新以加载新版本…'
			: '当前页面资源已过期，请刷新后继续。'
		: isRouteErrorResponse(error)
			? error.statusText || `请求失败（${error.status}）`
			: error?.message || '发生未知错误，请稍后重试。';
	const canGoBack = !chunkStale && typeof window !== 'undefined' && window.history.length > 1;

	return (
		<div
			className='app-release-reload app-release-reload--page'
			role='alertdialog'
			aria-labelledby='route-error-title'
			aria-describedby='route-error-desc'
		>
			<div className='app-release-reload__card'>
				<p id='route-error-title' className='app-release-reload__title'>
					{title}
				</p>
				<p id='route-error-desc' className='app-release-reload__desc'>
					{description}
				</p>
				<div className='app-release-reload__card-actions'>
					{canGoBack ? (
						<button
							type='button'
							className='btn btn-falcon-default btn-sm'
							onClick={() => {
								window.history.back();
							}}
						>
							返回上一页
						</button>
					) : null}
					{!chunkStale ? (
						<button
							type='button'
							className='btn btn-falcon-default btn-sm'
							onClick={() => {
								window.location.assign('/dashboard');
							}}
						>
							返回首页
						</button>
					) : null}
					<button
						type='button'
						className='btn btn-primary btn-sm'
						disabled={isPreparing}
						onClick={async () => {
							if (chunkStale) {
								setIsPreparing(true);
								await navigateToLatestRelease();
								return;
							}
							window.location.reload();
						}}
					>
						{isPreparing ? '切换中…' : '立即刷新'}
					</button>
				</div>
			</div>
		</div>
	);
};

export default RouteErrorBoundary;
